// from: /Resources/Private/Layouts/Page/Default.html
const pathsElement = document.getElementById('js-paths');

const cssPath = pathsElement.dataset.css;

//const modulePath   = pathsElement.dataset.module;
//const vendorPath   = pathsElement.dataset.vendor;


const initImageSlider = () => {

    const imageSlider = document.querySelectorAll('.swiper.imageSlider__container');
    
    if (imageSlider[0]) {

        import(
            /* webpackChunkName: "webpack-swiper-imageslider" */
            './Module/swiper-imageslider.js'
        ).then(module => {
            module.initSwiper(imageSlider);
        }).catch(err => {
            console.error('Error in imageSlider module: ', err);
        });
    }
};

const initTextMediaSlider = () => {

    const textMediaSlider = document.querySelectorAll('.swiper.gallerySlider');
    
    if (textMediaSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-textmediaslider" */
            './Module/swiper-textmediaslider.js'
        ).then(module => {
            module.initSwiper(textMediaSlider);
        }).catch(err => {
            console.error('Error in swiper-textmediaslider module: ', err);
        });
    }
};

const initProductDetailSlider = () => {

    const productSlider = document.querySelectorAll('.productSlider');
    
    if (productSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-productSlider" */
            './Module/swiper-productSlider.js'
        ).then(module => {
            module.initSwiper(productSlider);
        }).catch(err => {
            console.error('Error in ProductSlider module: ', err);
        });
    }
};


const initRelatedProductsSlider = () => {

    const relatedProductsSlider = document.querySelectorAll('.productsSlider .swiper');
    
    if (relatedProductsSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-relatedProductsSlider" */
            './Module/swiper-productsSlider.js'
        ).then(module => {
            module.initSwiper(relatedProductsSlider);
        }).catch(err => {
            console.error('Error in relatedProductsSlider module: ', err);
        });
    }
};

const initAccordions = () => {

    const accordionSelector = '.js-accordion';
  
    if (document.querySelector(accordionSelector)) {

        import(
            /* webpackChunkName: "webpack-accordions" */
            './Module/accordions.js').then(module => {
            module.initAccordion(accordionSelector);
        })
        .catch(error => {
            console.error('Error in accordion module: ', error);
        });
    }
};


const initVideos = () => {

    const videoWrappers = document.querySelectorAll('.video');
    
    if (videoWrappers[0]) {

        videoWrappers.forEach((videoWrap) => {

            const video       = videoWrap.querySelector('video');
            const button      = videoWrap.querySelector('.video__posterButton');
            const posterImage = videoWrap.querySelector('.video__poster');
            
            if(!button || !posterImage) return;

            button.addEventListener('click', () => {
                video.play();
                if (posterImage) posterImage.style.opacity = '0';
            })  
        })
    }
}


const initMenu = () => {

    import(
        /* webpackChunkName: "webpack-menu" */
        './Module/menu.js'
    ).then(module => {
        module.initMenu();
    })
    .catch(error => {
        console.error('Error in menu module: ', error);
    });

};


const initFocus = () => {

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            document.body.classList.remove('js-hideOutline');
        }
    });

    document.addEventListener('mousedown', function() {
        document.body.classList.add('js-hideOutline');
    });
};


const initScrolledListener = () => {

    document.addEventListener('scroll', () => {

        if (window.scrollY > 50) {
            document.body.classList.add('js-scrolled');
        } else {
            document.body.classList.remove('js-scrolled');
        }

        document.body.classList.remove('js-navOpened');
    });
};

// To track  and change header color
const checkAndToggleClass = () => {
    const header = document.querySelector('.header');
    const targetElement = document.querySelector('.frame');

    // Check if .frame exists before proceeding
    if (!targetElement) return;

    if (targetElement.classList.contains('stage')) {
        header.classList.add('header--stage');
    } else {
        header.classList.remove('header--stage');
    }
};


const initNewsMasonry = () => {

    const newsList = document.querySelector('.newsList__inner');
    
    if (newsList) {

        const msnry = new Masonry( newsList, {
            itemSelector: '.newsListArticle',
            columnWidth: '.newsListArticle',
            gutter: '.newsList__gutterSizer',
            percentPosition: true
        });
    }
}


const initNewsPaging = async () => {

    const available = document.querySelector('.newsList');

    if(!available) return;
    const {default: AjaxAppend} = await import(
        /* webpackChunkName: "webpack-ajaxAppend" */
        './Module/ajaxAppend.js');

    const newsPagingToggle = new AjaxAppend({
        button:     '.newsList__loadMore',
        container:  '.newsList',
        callback:   initNewsMasonry
    });
};


const initNewsCategories = async () => {

    const available = document.querySelector('.newsCategories__itemLink');

    if(!available) return;

    const {default: AjaxReplace} = await import(
        /* webpackChunkName: "webpack-ajaxReplace" */
        './Module/ajaxReplace.js');

    const newsCategoryToggle = new AjaxReplace({
        button:    '.newsCategories__itemLink',
        container: '.newsList',
        callback:   initNewsMasonry
    });
};


const initLottie = async () => {

    const lottieContainers = document.querySelectorAll('.lottie');
    
    if (lottieContainers[0]) {

        const {DotLottie} = await import(
            /* webpackChunkName: "webpack-dotlottie" */
            './Vendor/dotlottie.js');

        lottieContainers.forEach(element => {

            const filePath = element.dataset.path;

            new DotLottie({
                autoplay: true,
                loop: true,
                canvas: element,
                src: filePath,
            });
        });
    }
}


const initSearch = () => {
    const searchButtons = document.querySelectorAll('.js-searchButton');

    if (searchButtons.length > 0) {
        import(
            /* webpackChunkName: "webpack-search" */
            './Module/search.js'
        ).then(module => {
            module.default(searchButtons);
        }).catch(err => {
            console.error('Error loading search module: ', err);
        });
    }
};


const initSearchSuggest = () => {
    import(
        /* webpackChunkName: "webpack-search-suggest" */
        './Module/search-suggest.js'
    ).then(module => {
        module.initSuggest();
    }).catch(err => {
        console.error('Error loading search-suggest module: ', err);
    });    
}


document.addEventListener("DOMContentLoaded", () => {
    initImageSlider();
    initTextMediaSlider();
    initProductDetailSlider();
    initRelatedProductsSlider();
    initAccordions();
    initVideos();
    initMenu();  
    initFocus();
    initScrolledListener();
    checkAndToggleClass();
    initNewsMasonry();
    initNewsPaging();
    initNewsCategories();
    initLottie();
    initSearch();
    initSearchSuggest();
});




